import httpNodeClient from '@shared/api/httpNodeClient';

export const fetchFeaturesData = (): Promise<string[]> =>
  httpNodeClient.get<string[]>('/users/features').then((resp) => resp.data);
